<template>
    <div style="height: 100%">
        <div v-if="params.data.total_time_worked > params.data.project_hours" style="height: 100%">
            <vs-chip class="mr-3" style="height: 60%; top:20%" color="danger">{{ params.value }}</vs-chip>
        </div>
        <div v-else>
            {{ params.value }}
        </div>
    </div>
</template>
<script>
    import Vue from "vue";

    export default Vue.extend({
    });

</script>
